export declare interface CreateCoverImage {
  alt?: string;
  httpUrl?: string;
  type?: string;
}

export declare interface CreateCustomCourseInfo {
  courseName?: string;
  courseNo?: string;
}

export declare interface CreateCustomProductMetadata {
  courses?: CreateCustomCourseInfo[];
  createCoverImages?: CreateCoverImage[];
  deliveryTypes?: string[];
  department?: string;
  instructorNames?: string[];
  school?: CreateCustomSchool;
  supplements?: CreateCustomProductSupplement[];
}

export declare interface CreateCustomProductSupplement {
  active: boolean;
  copyrightYear: number;
  description: string;
  id: string;
  isbn10: string;
  isbn13: string;
  locked: boolean;
  name: string;
  offerId: number;
  price: number;
  productType: string;
  salable: boolean;
  searchable: boolean;
  status: string;
  terms?: CreateTerms;
}

export declare interface CreateCustomSchool {
  id?: string;
  name?: string;
  partyId?: string;
}

export enum CreateProductFormat {
  MHE_READER = 'MHE_READER',
  VITALSOURCE_DONLOAD = 'VITALSOURCE_DONLOAD', // Backend typo that we need to support until it is fixed
  VITALSOURCE_DOWNLOAD = 'VITALSOURCE_DOWNLOAD',
  VITALSOURCE_ONLINE = 'VITALSOURCE_ONLINE',
}

export declare interface CreateTerms {
  days: number;
  name: string;
}
